import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router-dom'
import createHistory from 'history/createBrowserHistory'
import Highcharts from 'highcharts/highcharts'
import HighchartsGauge from 'highcharts/highcharts'
import HighStock from 'highcharts/highstock'
import highchartsMore from "highcharts/highcharts-more"
import solidGauge from "highcharts/modules/solid-gauge"
import HighchartsReact from 'highcharts-react-official'
import { getDefaultDataViewDashboard } from '../../actions/DataViewDashboardActions'
import { createAnalyticsItemView } from '../../actions/AnalyticsItemViewActions'
import SiteContainer from '../../components/layout/SiteContainer'
import ContainerHeading from '../../components/layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import LoadingScreen from '../../components/LoadingScreen'
import { GaugeSetContainer, GaugeContainer, GaugeHeading, GaugePlusDetailsContainer, GaugePlusDetailsHeading, InnerGaugeContainer, GaugePlusDetailsSparklineContainer, GaugePlusDetailsMinMaxAvgContainer, GaugePlusDetailsMinMaxAvgRow, GaugePlusDetailsMinMaxAvgRowHeading, GaugePlusDetailsMinMaxAvgRowDetail, DataViewContainer, DataViewHeadingDiv, DataViewHeadingText, DataViewHeadingLinks, DataViewBody, DashboardGraphHeadingExpandLinkCell, DashboardGraphHeadingExpandLink } from './styled-elements'
import Moment from 'moment-timezone'
import styledTheme from '../../styles/theme'

highchartsMore(HighchartsGauge)
solidGauge(HighchartsGauge)

class DefaultDataViewDashboard extends React.Component {

  constructor(props) {
    super(props)
    const { params } = props.match
  }

  componentDidMount() {
    const { dispatch, match, dataViewDashboards } = this.props
    dispatch(getDefaultDataViewDashboard())
    { dataViewDashboards.default && dispatch(createAnalyticsItemView('data_view_dashboard',dataViewDashboards.default.id)) }
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === 'visible') {
        dispatch(getDefaultDataViewDashboard())
      }
    })
    window.addEventListener("focus", () => {
      console.log("XXX document.hasFocus()",document.hasFocus())
    })
    setInterval(() => {
      dispatch(getDefaultDataViewDashboard())
    },600000)
  }

  componentDidUpdate(prevProps,prevState,snapshot) {
    const { dispatch, match, dataViewDashboards } = this.props
    this.removeHighchartsCredit.call(this)
    const dashboardId = (dataViewDashboards.default) && dataViewDashboards.default.id
    const prevDashboardId = (prevProps.dataViewDashboards.default) && prevProps.dataViewDashboards.default.id
    if (dashboardId && (dashboardId!=prevDashboardId)) {
      dispatch(createAnalyticsItemView('data_view_dashboard',dashboardId))
    }
  }

  getLoadingScreenState() {
    const { apiAuth, dataViewDashboards } = this.props
    return (
      apiAuth.validating ||
      dataViewDashboards.fetchingDefault
    )
  }


  formatSeries = (seriesArray) => seriesArray.map(series => {
    if (series.yAxis==='y_axis_percent' && series.offset_enabled) {
      return {
        ...series,
        tooltip: {
          pointFormatter: function() {
            return '<span style="color:' + this.color + '">\u25CF</span> ' + series.name + ' <b>' + (this.y+series.offset).toFixed(2) + '%</b><br/>'
          }
        }
      }
    }
    return series
  })

  routeChange=(path)=> {
    this.props.dispatch(push(path))
  }

  processOptions = (chart,props,state) => {
    const options = chart.chart_obj
    const mobileDisplayOptions = {}
    options['scrollbar'] = { enabled: false }
    options['rangeSelector'] = {
      enabled: true,
      selected: 3,
      inputEnabled: false,
      buttons: [{
        type: 'day',
        count: 1,
        text: '1d'
      },{
        type: 'day',
        count: 2,
        text: '2d'
      },{
        type: 'day',
        count: 7,
        text: '1w'
      },{
        type: 'day',
        count: 14,
        text: '2w'
      },{
        type: 'day',
        count: 28,
        text: '4w'
      }]
    }
    const xAxis = options['xAxis']
    const maxUnixTimeMoment = Moment(new Date(xAxis[0]['max']))
    const twoDaysAgoUnixtime = maxUnixTimeMoment.clone().subtract(14,'days')
    const xAxisRange = maxUnixTimeMoment.diff(twoDaysAgoUnixtime)
    xAxis[0]['min'] = xAxis[0]['max']-xAxisRange
    return {
      ...options,
      ...mobileDisplayOptions,
      series: options.series ? this.formatSeries(options.series.slice()) : [],
      time: {
        getTimezoneOffset: function (timestamp) {
          return -Moment.tz(timestamp, chart.timezone_name).utcOffset()
        }
      }
    }
  }

  removeHighchartsCredit = () => {
    const highchartsCreditElArray = document.querySelectorAll('.highcharts-credits')
    if (highchartsCreditElArray.length) {
      highchartsCreditElArray.forEach((highchartsCredit) => {
        highchartsCredit.parentNode.removeChild(highchartsCredit)
      })
    }
  }

  renderDashboard = (dashboardObj,props,state) => {

    const gauges = dashboardObj.gauges && dashboardObj.gauges.filter((gauge) => Object.keys(gauge.gauge_obj).length > 0).map((displayObjectHash,index) => {

      let gaugeObj
      let detailsObj
      let sparklineObj

      if (displayObjectHash.data_view_type_category === 'gauge') {
        gaugeObj = displayObjectHash.gauge_obj
      } else if (displayObjectHash.data_view_type_category === 'gauge_plus_details') {
        gaugeObj = displayObjectHash.gauge_obj.gauge_chart_obj
        sparklineObj = displayObjectHash.gauge_obj.area_chart_obj
        detailsObj = displayObjectHash.gauge_obj
      }

      gaugeObj['tooltip']['pointFormat'] = '{series.name}<br><span style="font-size:2em; color: \'#333333\'; font-weight: bold">{point.y}</span>'
      gaugeObj['tooltip']['positioner'] = function (labelWidth) {
        return {
          x: (this.chart.chartWidth - labelWidth) / 2,
          y: (this.chart.plotHeight/2.2)
        }
      }

      if (displayObjectHash.data_view_type_category === 'gauge') {

        return <GaugePlusDetailsContainer key={index}>
          <GaugePlusDetailsHeading>
            <DataViewHeadingText>{displayObjectHash.title}</DataViewHeadingText>
            {displayObjectHash.links && <DataViewHeadingLinks>{displayObjectHash.links.map((link,index) =>
              <DashboardGraphHeadingExpandLinkCell key={index}>
                <DashboardGraphHeadingExpandLink onClick={this.routeChange.bind(this,link.path)}>{link.label}</DashboardGraphHeadingExpandLink>
              </DashboardGraphHeadingExpandLinkCell>
           )}</DataViewHeadingLinks>}
          </GaugePlusDetailsHeading>
          <InnerGaugeContainer>
            <HighchartsReact
              highcharts={HighchartsGauge}
              options={gaugeObj}
              allowChartUpdate={true}
            />
          </InnerGaugeContainer>
        </GaugePlusDetailsContainer>

      } else if (displayObjectHash.data_view_type_category === 'gauge_plus_details') {

        return <GaugePlusDetailsContainer key={index}>
          <GaugePlusDetailsHeading>
            <DataViewHeadingText>{displayObjectHash.title}</DataViewHeadingText>
            {displayObjectHash.links && <DataViewHeadingLinks>{displayObjectHash.links.map((link,index) =>
              <DashboardGraphHeadingExpandLinkCell key={index}>
                <DashboardGraphHeadingExpandLink onClick={this.routeChange.bind(this,link.path)}>{link.label}</DashboardGraphHeadingExpandLink>
              </DashboardGraphHeadingExpandLinkCell>
           )}</DataViewHeadingLinks>}
          </GaugePlusDetailsHeading>
          <InnerGaugeContainer>
            <HighchartsReact
              highcharts={HighchartsGauge}
              options={gaugeObj}
              allowChartUpdate={true}
            />
            </InnerGaugeContainer>
            <GaugePlusDetailsSparklineContainer>
              <HighchartsReact
                highcharts={Highcharts}
                constructorType={'chart'}
                options={sparklineObj}
                allowChartUpdate={true}
              />
            </GaugePlusDetailsSparklineContainer>
            {(detailsObj.min_string || detailsObj.max_string || detailsObj.average_string) && <GaugePlusDetailsMinMaxAvgContainer>
              {detailsObj.min_string && <GaugePlusDetailsMinMaxAvgRow>
                <GaugePlusDetailsMinMaxAvgRowHeading>
                  Min:
                </GaugePlusDetailsMinMaxAvgRowHeading>
                <GaugePlusDetailsMinMaxAvgRowDetail>
                  {detailsObj.min_string}
                </GaugePlusDetailsMinMaxAvgRowDetail>
              </GaugePlusDetailsMinMaxAvgRow>}

              {detailsObj.max_string && <GaugePlusDetailsMinMaxAvgRow>
                <GaugePlusDetailsMinMaxAvgRowHeading>
                  Max:
                </GaugePlusDetailsMinMaxAvgRowHeading>
                <GaugePlusDetailsMinMaxAvgRowDetail>
                  {detailsObj.max_string}
                </GaugePlusDetailsMinMaxAvgRowDetail>
              </GaugePlusDetailsMinMaxAvgRow>}

              {detailsObj.average_string && <GaugePlusDetailsMinMaxAvgRow>
                <GaugePlusDetailsMinMaxAvgRowHeading>
                  Average:
                </GaugePlusDetailsMinMaxAvgRowHeading>
                <GaugePlusDetailsMinMaxAvgRowDetail>
                  {detailsObj.average_string}
                </GaugePlusDetailsMinMaxAvgRowDetail>
              </GaugePlusDetailsMinMaxAvgRow>}

            </GaugePlusDetailsMinMaxAvgContainer>}
        </GaugePlusDetailsContainer>
      }
    })

    const gaugeSet = (gauges &&
      <GaugeSetContainer>{gauges}</GaugeSetContainer>
    )

    const charts = dashboardObj.charts && dashboardObj.charts.filter((chart) => Object.keys(chart.chart_obj).length > 0).map((chart,index) => {
      let options = this.processOptions(chart,props,state)

      return <DataViewContainer key={index}>
        <DataViewHeadingDiv>
          <DataViewHeadingText>{chart.title}</DataViewHeadingText>
          <DataViewHeadingLinks>{chart.links && chart.links.map((link,index) =>
            <DashboardGraphHeadingExpandLinkCell key={index}>
              <DashboardGraphHeadingExpandLink onClick={this.routeChange.bind(this,link.path)}>{link.label}</DashboardGraphHeadingExpandLink>
            </DashboardGraphHeadingExpandLinkCell>
          )}
          </DataViewHeadingLinks>
        </DataViewHeadingDiv>
      <DataViewBody>
        <HighchartsReact
          highcharts={HighStock}
          constructorType={'stockChart'}
          options={options}
          allowChartUpdate={true}
        />
      </DataViewBody>
    </DataViewContainer>})

    const ret = <div>
      {gaugeSet}
      {charts}
    </div>

    return ret
  }

  renderBody = (props,state) => {
    return <div>
      <LoadingScreen show={this.getLoadingScreenState()}/>
      { props.dataViewDashboards.default && props.dataViewDashboards.default.charts && this.renderDashboard(props.dataViewDashboards.default,props,state) }
    </div>
  }

  render = () => <SiteContainer isSignedIn={this.props.apiAuth.isSignedIn}>
    <HelmetTitle title={`Dashboard`} />
    {this.renderBody(this.props,this.state)}
  </SiteContainer>

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    dataViewDashboards: store.dataViewDashboards,
    routing: store.routing,
  }),
)(DefaultDataViewDashboard)




// WEBPACK FOOTER //
// ./src/containers/dashboard/defaultDataViewDashboard.js